import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { StateConfigContext } from '../../providers';
import { getTestId } from '../../utils/commonUtils';
import { MultipleText } from './components/multi-text/MultiText';
import { SingleText } from './components/single-text/SingleText';
import { getTypographyProps } from './TypographyStyles';
export var Typography = forwardRef((props, ref) => {
  var stateContext = useContext(StateConfigContext);
  var typographyProps = getTypographyProps(props, stateContext);
  var text = typographyProps.text,
    multiText = typographyProps.multiText,
    _typographyProps$test = typographyProps.testID,
    testID = _typographyProps$test === void 0 ? 'Typography' : _typographyProps$test;
  return _jsxs(_Fragment, {
    children: [!!text && _jsx(SingleText, Object.assign({
      ref: ref
    }, typographyProps, getTestId(testID))), (multiText === null || multiText === void 0 ? void 0 : multiText.length) > 0 && _jsx(MultipleText, Object.assign({
      ref: ref
    }, typographyProps, getTestId(testID)))]
  });
});